export default {"src":"/_next/static/media/cplusplus.d264bdc1.svg","height":288,"width":256,"blurWidth":0,"blurHeight":0};